export function downloadCsv(link?: string) {
  if (!link) return;

  const safe = encodeURI(link);
  const win = window.open(safe, '_blank', 'noopener,noreferrer');
  
  if (win) win.opener = null;
}